enum TypeDataEvent {
	delete = "delete",
	edit = "edit",
	create = "create"
}

export default TypeDataEvent